import { useAtom } from "jotai";

import { QUIZ_QUESTION_CHANGE_ANSWER_LIMIT_LABEL } from "../../widget.constants";
import { quizAtom } from "../../widget.state";

export function QuestionFeedback({
  isCorrect,
  isSingleQuestionQuestion,
}: {
  isCorrect: boolean;
  isSingleQuestionQuestion?: boolean;
}) {
  const [quiz] = useAtom(quizAtom);

  return isCorrect ? (
    <div className="quiz__feedback quiz__feedback--correct">
      +1 Extra {quiz.isArcade ? "point" : "entry"}. Correct!
    </div>
  ) : (
    <div className="quiz__feedback quiz__feedback--incorrect">
      {quiz.isArcade
        ? "Incorrect answer!"
        : "Change your answer to earn +1 Entry"}
      {!quiz.isArcade && isSingleQuestionQuestion && (
        <>
          <br />
          <strong>You have {QUIZ_QUESTION_CHANGE_ANSWER_LIMIT_LABEL}</strong>
        </>
      )}
    </div>
  );
}
